import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/domconverter
 */

/* globals document, Node, NodeFilter, Text */
import ViewText from './text';
import ViewElement from './element';
import ViewPosition from './position';
import ViewRange from './range';
import ViewSelection from './selection';
import ViewDocumentFragment from './documentfragment';
import ViewTreeWalker from './treewalker';
import { BR_FILLER, getDataWithoutFiller, INLINE_FILLER_LENGTH, isInlineFiller, NBSP_FILLER, startsWithFiller } from './filler';
import global from '@ckeditor/ckeditor5-utils/src/dom/global';
import indexOf from '@ckeditor/ckeditor5-utils/src/dom/indexof';
import getAncestors from '@ckeditor/ckeditor5-utils/src/dom/getancestors';
import getCommonAncestor from '@ckeditor/ckeditor5-utils/src/dom/getcommonancestor';
import isText from '@ckeditor/ckeditor5-utils/src/dom/istext';
import { isElement } from 'lodash-es'; // eslint-disable-next-line new-cap

var BR_FILLER_REF = BR_FILLER(document);
/**
 * DomConverter is a set of tools to do transformations between DOM nodes and view nodes. It also handles
 * {@link module:engine/view/domconverter~DomConverter#bindElements binding} these nodes.
 *
 * The instance of DOMConverter is available in {@link module:engine/view/view~View#domConverter `editor.editing.view.domConverter`}.
 *
 * DomConverter does not check which nodes should be rendered (use {@link module:engine/view/renderer~Renderer}), does not keep a
 * state of a tree nor keeps synchronization between tree view and DOM tree (use {@link module:engine/view/document~Document}).
 *
 * DomConverter keeps DOM elements to View element bindings, so when the converter will be destroyed, the binding will
 * be lost. Two converters will keep separate binding maps, so one tree view can be bound with two DOM trees.
 */

var DomConverter =
/*#__PURE__*/
function () {
  /**
   * Creates DOM converter.
   *
   * @param {module:engine/view/document~Document} document The view document instance.
   * @param {Object} options Object with configuration options.
   * @param {module:engine/view/filler~BlockFillerMode} [options.blockFillerMode='br'] The type of the block filler to use.
   */
  function DomConverter(document) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, DomConverter);

    /**
     * @readonly
     * @type {module:engine/view/document~Document}
     */
    this.document = document;
    /**
     * The mode of a block filler used by DOM converter.
     *
     * @readonly
     * @member {'br'|'nbsp'} module:engine/view/domconverter~DomConverter#blockFillerMode
     */

    this.blockFillerMode = options.blockFillerMode || 'br';
    /**
     * Elements which are considered pre-formatted elements.
     *
     * @readonly
     * @member {Array.<String>} module:engine/view/domconverter~DomConverter#preElements
     */

    this.preElements = ['pre'];
    /**
     * Elements which are considered block elements (and hence should be filled with a
     * {@link #isBlockFiller block filler}).
     *
     * Whether an element is considered a block element also affects handling of trailing whitespaces.
     *
     * You can extend this array if you introduce support for block elements which are not yet recognized here.
     *
     * @readonly
     * @member {Array.<String>} module:engine/view/domconverter~DomConverter#blockElements
     */

    this.blockElements = ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'dd', 'dt', 'figcaption'];
    /**
     * Block {@link module:engine/view/filler filler} creator, which is used to create all block fillers during the
     * view to DOM conversion and to recognize block fillers during the DOM to view conversion.
     *
     * @readonly
     * @private
     * @member {Function} module:engine/view/domconverter~DomConverter#_blockFiller
     */

    this._blockFiller = this.blockFillerMode == 'br' ? BR_FILLER : NBSP_FILLER;
    /**
     * DOM to View mapping.
     *
     * @private
     * @member {WeakMap} module:engine/view/domconverter~DomConverter#_domToViewMapping
     */

    this._domToViewMapping = new WeakMap();
    /**
     * View to DOM mapping.
     *
     * @private
     * @member {WeakMap} module:engine/view/domconverter~DomConverter#_viewToDomMapping
     */

    this._viewToDomMapping = new WeakMap();
    /**
     * Holds mapping between fake selection containers and corresponding view selections.
     *
     * @private
     * @member {WeakMap} module:engine/view/domconverter~DomConverter#_fakeSelectionMapping
     */

    this._fakeSelectionMapping = new WeakMap();
  }
  /**
   * Binds given DOM element that represents fake selection to a **position** of a
   * {@link module:engine/view/documentselection~DocumentSelection document selection}.
   * Document selection copy is stored and can be retrieved by
   * {@link module:engine/view/domconverter~DomConverter#fakeSelectionToView} method.
   *
   * @param {HTMLElement} domElement
   * @param {module:engine/view/documentselection~DocumentSelection} viewDocumentSelection
   */


  _createClass(DomConverter, [{
    key: "bindFakeSelection",
    value: function bindFakeSelection(domElement, viewDocumentSelection) {
      this._fakeSelectionMapping.set(domElement, new ViewSelection(viewDocumentSelection));
    }
    /**
     * Returns {@link module:engine/view/selection~Selection view selection} instance corresponding to
     * given DOM element that represents fake selection. Returns `undefined` if binding to given DOM element does not exists.
     *
     * @param {HTMLElement} domElement
     * @returns {module:engine/view/selection~Selection|undefined}
     */

  }, {
    key: "fakeSelectionToView",
    value: function fakeSelectionToView(domElement) {
      return this._fakeSelectionMapping.get(domElement);
    }
    /**
     * Binds DOM and View elements, so it will be possible to get corresponding elements using
     * {@link module:engine/view/domconverter~DomConverter#mapDomToView} and
     * {@link module:engine/view/domconverter~DomConverter#mapViewToDom}.
     *
     * @param {HTMLElement} domElement DOM element to bind.
     * @param {module:engine/view/element~Element} viewElement View element to bind.
     */

  }, {
    key: "bindElements",
    value: function bindElements(domElement, viewElement) {
      this._domToViewMapping.set(domElement, viewElement);

      this._viewToDomMapping.set(viewElement, domElement);
    }
    /**
     * Unbinds given `domElement` from the view element it was bound to. Unbinding is deep, meaning that all children of
     * `domElement` will be unbound too.
     *
     * @param {HTMLElement} domElement DOM element to unbind.
     */

  }, {
    key: "unbindDomElement",
    value: function unbindDomElement(domElement) {
      var viewElement = this._domToViewMapping.get(domElement);

      if (viewElement) {
        this._domToViewMapping.delete(domElement);

        this._viewToDomMapping.delete(viewElement); // Use Array.from because of MS Edge (#923).


        for (var _i = 0, _Array$from = Array.from(domElement.childNodes); _i < _Array$from.length; _i++) {
          var child = _Array$from[_i];
          this.unbindDomElement(child);
        }
      }
    }
    /**
     * Binds DOM and View document fragments, so it will be possible to get corresponding document fragments using
     * {@link module:engine/view/domconverter~DomConverter#mapDomToView} and
     * {@link module:engine/view/domconverter~DomConverter#mapViewToDom}.
     *
     * @param {DocumentFragment} domFragment DOM document fragment to bind.
     * @param {module:engine/view/documentfragment~DocumentFragment} viewFragment View document fragment to bind.
     */

  }, {
    key: "bindDocumentFragments",
    value: function bindDocumentFragments(domFragment, viewFragment) {
      this._domToViewMapping.set(domFragment, viewFragment);

      this._viewToDomMapping.set(viewFragment, domFragment);
    }
    /**
     * Converts view to DOM. For all text nodes, not bound elements and document fragments new items will
     * be created. For bound elements and document fragments function will return corresponding items.
     *
     * @param {module:engine/view/node~Node|module:engine/view/documentfragment~DocumentFragment} viewNode
     * View node or document fragment to transform.
     * @param {Document} domDocument Document which will be used to create DOM nodes.
     * @param {Object} [options] Conversion options.
     * @param {Boolean} [options.bind=false] Determines whether new elements will be bound.
     * @param {Boolean} [options.withChildren=true] If `true`, node's and document fragment's children will be converted too.
     * @returns {Node|DocumentFragment} Converted node or DocumentFragment.
     */

  }, {
    key: "viewToDom",
    value: function viewToDom(viewNode, domDocument) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (viewNode.is('text')) {
        var textData = this._processDataFromViewText(viewNode);

        return domDocument.createTextNode(textData);
      } else {
        if (this.mapViewToDom(viewNode)) {
          return this.mapViewToDom(viewNode);
        }

        var domElement;

        if (viewNode.is('documentFragment')) {
          // Create DOM document fragment.
          domElement = domDocument.createDocumentFragment();

          if (options.bind) {
            this.bindDocumentFragments(domElement, viewNode);
          }
        } else if (viewNode.is('uiElement')) {
          // UIElement has its own render() method (see #799).
          domElement = viewNode.render(domDocument);

          if (options.bind) {
            this.bindElements(domElement, viewNode);
          }

          return domElement;
        } else {
          // Create DOM element.
          if (viewNode.hasAttribute('xmlns')) {
            domElement = domDocument.createElementNS(viewNode.getAttribute('xmlns'), viewNode.name);
          } else {
            domElement = domDocument.createElement(viewNode.name);
          }

          if (options.bind) {
            this.bindElements(domElement, viewNode);
          } // Copy element's attributes.


          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = viewNode.getAttributeKeys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var key = _step.value;
              domElement.setAttribute(key, viewNode.getAttribute(key));
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        if (options.withChildren || options.withChildren === undefined) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = this.viewChildrenToDom(viewNode, domDocument, options)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var child = _step2.value;
              domElement.appendChild(child);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }

        return domElement;
      }
    }
    /**
     * Converts children of the view element to DOM using the
     * {@link module:engine/view/domconverter~DomConverter#viewToDom} method.
     * Additionally, this method adds block {@link module:engine/view/filler filler} to the list of children, if needed.
     *
     * @param {module:engine/view/element~Element|module:engine/view/documentfragment~DocumentFragment} viewElement Parent view element.
     * @param {Document} domDocument Document which will be used to create DOM nodes.
     * @param {Object} options See {@link module:engine/view/domconverter~DomConverter#viewToDom} options parameter.
     * @returns {Iterable.<Node>} DOM nodes.
     */

  }, {
    key: "viewChildrenToDom",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function viewChildrenToDom(viewElement, domDocument) {
      var options,
          fillerPositionOffset,
          offset,
          _iteratorNormalCompletion3,
          _didIteratorError3,
          _iteratorError3,
          _iterator3,
          _step3,
          childView,
          _args = arguments;

      return _regeneratorRuntime.wrap(function viewChildrenToDom$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              fillerPositionOffset = viewElement.getFillerOffset && viewElement.getFillerOffset();
              offset = 0;
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context.prev = 6;
              _iterator3 = viewElement.getChildren()[Symbol.iterator]();

            case 8:
              if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                _context.next = 19;
                break;
              }

              childView = _step3.value;

              if (!(fillerPositionOffset === offset)) {
                _context.next = 13;
                break;
              }

              _context.next = 13;
              return this._blockFiller(domDocument);

            case 13:
              _context.next = 15;
              return this.viewToDom(childView, domDocument, options);

            case 15:
              offset++;

            case 16:
              _iteratorNormalCompletion3 = true;
              _context.next = 8;
              break;

            case 19:
              _context.next = 25;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](6);
              _didIteratorError3 = true;
              _iteratorError3 = _context.t0;

            case 25:
              _context.prev = 25;
              _context.prev = 26;

              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }

            case 28:
              _context.prev = 28;

              if (!_didIteratorError3) {
                _context.next = 31;
                break;
              }

              throw _iteratorError3;

            case 31:
              return _context.finish(28);

            case 32:
              return _context.finish(25);

            case 33:
              if (!(fillerPositionOffset === offset)) {
                _context.next = 36;
                break;
              }

              _context.next = 36;
              return this._blockFiller(domDocument);

            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, viewChildrenToDom, this, [[6, 21, 25, 33], [26,, 28, 32]]);
    })
    /**
     * Converts view {@link module:engine/view/range~Range} to DOM range.
     * Inline and block {@link module:engine/view/filler fillers} are handled during the conversion.
     *
     * @param {module:engine/view/range~Range} viewRange View range.
     * @returns {Range} DOM range.
     */

  }, {
    key: "viewRangeToDom",
    value: function viewRangeToDom(viewRange) {
      var domStart = this.viewPositionToDom(viewRange.start);
      var domEnd = this.viewPositionToDom(viewRange.end);
      var domRange = document.createRange();
      domRange.setStart(domStart.parent, domStart.offset);
      domRange.setEnd(domEnd.parent, domEnd.offset);
      return domRange;
    }
    /**
     * Converts view {@link module:engine/view/position~Position} to DOM parent and offset.
     *
     * Inline and block {@link module:engine/view/filler fillers} are handled during the conversion.
     * If the converted position is directly before inline filler it is moved inside the filler.
     *
     * @param {module:engine/view/position~Position} viewPosition View position.
     * @returns {Object|null} position DOM position or `null` if view position could not be converted to DOM.
     * @returns {Node} position.parent DOM position parent.
     * @returns {Number} position.offset DOM position offset.
     */

  }, {
    key: "viewPositionToDom",
    value: function viewPositionToDom(viewPosition) {
      var viewParent = viewPosition.parent;

      if (viewParent.is('text')) {
        var domParent = this.findCorrespondingDomText(viewParent);

        if (!domParent) {
          // Position is in a view text node that has not been rendered to DOM yet.
          return null;
        }

        var offset = viewPosition.offset;

        if (startsWithFiller(domParent)) {
          offset += INLINE_FILLER_LENGTH;
        }

        return {
          parent: domParent,
          offset: offset
        };
      } else {
        // viewParent is instance of ViewElement.
        var _domParent, domBefore, domAfter;

        if (viewPosition.offset === 0) {
          _domParent = this.mapViewToDom(viewParent);

          if (!_domParent) {
            // Position is in a view element that has not been rendered to DOM yet.
            return null;
          }

          domAfter = _domParent.childNodes[0];
        } else {
          var nodeBefore = viewPosition.nodeBefore;
          domBefore = nodeBefore.is('text') ? this.findCorrespondingDomText(nodeBefore) : this.mapViewToDom(viewPosition.nodeBefore);

          if (!domBefore) {
            // Position is after a view element that has not been rendered to DOM yet.
            return null;
          }

          _domParent = domBefore.parentNode;
          domAfter = domBefore.nextSibling;
        } // If there is an inline filler at position return position inside the filler. We should never return
        // the position before the inline filler.


        if (isText(domAfter) && startsWithFiller(domAfter)) {
          return {
            parent: domAfter,
            offset: INLINE_FILLER_LENGTH
          };
        }

        var _offset = domBefore ? indexOf(domBefore) + 1 : 0;

        return {
          parent: _domParent,
          offset: _offset
        };
      }
    }
    /**
     * Converts DOM to view. For all text nodes, not bound elements and document fragments new items will
     * be created. For bound elements and document fragments function will return corresponding items. For
     * {@link module:engine/view/filler fillers} `null` will be returned.
     * For all DOM elements rendered by {@link module:engine/view/uielement~UIElement} that UIElement will be returned.
     *
     * @param {Node|DocumentFragment} domNode DOM node or document fragment to transform.
     * @param {Object} [options] Conversion options.
     * @param {Boolean} [options.bind=false] Determines whether new elements will be bound.
     * @param {Boolean} [options.withChildren=true] If `true`, node's and document fragment's children will be converted too.
     * @param {Boolean} [options.keepOriginalCase=false] If `false`, node's tag name will be converter to lower case.
     * @returns {module:engine/view/node~Node|module:engine/view/documentfragment~DocumentFragment|null} Converted node or document fragment
     * or `null` if DOM node is a {@link module:engine/view/filler filler} or the given node is an empty text node.
     */

  }, {
    key: "domToView",
    value: function domToView(domNode) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.isBlockFiller(domNode, this.blockFillerMode)) {
        return null;
      } // When node is inside UIElement return that UIElement as it's view representation.


      var uiElement = this.getParentUIElement(domNode, this._domToViewMapping);

      if (uiElement) {
        return uiElement;
      }

      if (isText(domNode)) {
        if (isInlineFiller(domNode)) {
          return null;
        } else {
          var textData = this._processDataFromDomText(domNode);

          return textData === '' ? null : new ViewText(this.document, textData);
        }
      } else if (this.isComment(domNode)) {
        return null;
      } else {
        if (this.mapDomToView(domNode)) {
          return this.mapDomToView(domNode);
        }

        var viewElement;

        if (this.isDocumentFragment(domNode)) {
          // Create view document fragment.
          viewElement = new ViewDocumentFragment(this.document);

          if (options.bind) {
            this.bindDocumentFragments(domNode, viewElement);
          }
        } else {
          // Create view element.
          var viewName = options.keepOriginalCase ? domNode.tagName : domNode.tagName.toLowerCase();
          viewElement = new ViewElement(this.document, viewName);

          if (options.bind) {
            this.bindElements(domNode, viewElement);
          } // Copy element's attributes.


          var attrs = domNode.attributes;

          for (var i = attrs.length - 1; i >= 0; i--) {
            viewElement._setAttribute(attrs[i].name, attrs[i].value);
          }
        }

        if (options.withChildren || options.withChildren === undefined) {
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = this.domChildrenToView(domNode, options)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var child = _step4.value;

              viewElement._appendChild(child);
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }

        return viewElement;
      }
    }
    /**
     * Converts children of the DOM element to view nodes using
     * the {@link module:engine/view/domconverter~DomConverter#domToView} method.
     * Additionally this method omits block {@link module:engine/view/filler filler}, if it exists in the DOM parent.
     *
     * @param {HTMLElement} domElement Parent DOM element.
     * @param {Object} options See {@link module:engine/view/domconverter~DomConverter#domToView} options parameter.
     * @returns {Iterable.<module:engine/view/node~Node>} View nodes.
     */

  }, {
    key: "domChildrenToView",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function domChildrenToView(domElement) {
      var options,
          i,
          domChild,
          viewChild,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function domChildrenToView$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              i = 0;

            case 2:
              if (!(i < domElement.childNodes.length)) {
                _context2.next = 11;
                break;
              }

              domChild = domElement.childNodes[i];
              viewChild = this.domToView(domChild, options);

              if (!(viewChild !== null)) {
                _context2.next = 8;
                break;
              }

              _context2.next = 8;
              return viewChild;

            case 8:
              i++;
              _context2.next = 2;
              break;

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, domChildrenToView, this);
    })
    /**
     * Converts DOM selection to view {@link module:engine/view/selection~Selection}.
     * Ranges which cannot be converted will be omitted.
     *
     * @param {Selection} domSelection DOM selection.
     * @returns {module:engine/view/selection~Selection} View selection.
     */

  }, {
    key: "domSelectionToView",
    value: function domSelectionToView(domSelection) {
      // DOM selection might be placed in fake selection container.
      // If container contains fake selection - return corresponding view selection.
      if (domSelection.rangeCount === 1) {
        var container = domSelection.getRangeAt(0).startContainer; // The DOM selection might be moved to the text node inside the fake selection container.

        if (isText(container)) {
          container = container.parentNode;
        }

        var viewSelection = this.fakeSelectionToView(container);

        if (viewSelection) {
          return viewSelection;
        }
      }

      var isBackward = this.isDomSelectionBackward(domSelection);
      var viewRanges = [];

      for (var i = 0; i < domSelection.rangeCount; i++) {
        // DOM Range have correct start and end, no matter what is the DOM Selection direction. So we don't have to fix anything.
        var domRange = domSelection.getRangeAt(i);
        var viewRange = this.domRangeToView(domRange);

        if (viewRange) {
          viewRanges.push(viewRange);
        }
      }

      return new ViewSelection(viewRanges, {
        backward: isBackward
      });
    }
    /**
     * Converts DOM Range to view {@link module:engine/view/range~Range}.
     * If the start or end position can not be converted `null` is returned.
     *
     * @param {Range} domRange DOM range.
     * @returns {module:engine/view/range~Range|null} View range.
     */

  }, {
    key: "domRangeToView",
    value: function domRangeToView(domRange) {
      var viewStart = this.domPositionToView(domRange.startContainer, domRange.startOffset);
      var viewEnd = this.domPositionToView(domRange.endContainer, domRange.endOffset);

      if (viewStart && viewEnd) {
        return new ViewRange(viewStart, viewEnd);
      }

      return null;
    }
    /**
     * Converts DOM parent and offset to view {@link module:engine/view/position~Position}.
     *
     * If the position is inside a {@link module:engine/view/filler filler} which has no corresponding view node,
     * position of the filler will be converted and returned.
     *
     * If the position is inside DOM element rendered by {@link module:engine/view/uielement~UIElement}
     * that position will be converted to view position before that UIElement.
     *
     * If structures are too different and it is not possible to find corresponding position then `null` will be returned.
     *
     * @param {Node} domParent DOM position parent.
     * @param {Number} domOffset DOM position offset.
     * @returns {module:engine/view/position~Position} viewPosition View position.
     */

  }, {
    key: "domPositionToView",
    value: function domPositionToView(domParent, domOffset) {
      if (this.isBlockFiller(domParent, this.blockFillerMode)) {
        return this.domPositionToView(domParent.parentNode, indexOf(domParent));
      } // If position is somewhere inside UIElement - return position before that element.


      var viewElement = this.mapDomToView(domParent);

      if (viewElement && viewElement.is('uiElement')) {
        return ViewPosition._createBefore(viewElement);
      }

      if (isText(domParent)) {
        if (isInlineFiller(domParent)) {
          return this.domPositionToView(domParent.parentNode, indexOf(domParent));
        }

        var viewParent = this.findCorrespondingViewText(domParent);
        var offset = domOffset;

        if (!viewParent) {
          return null;
        }

        if (startsWithFiller(domParent)) {
          offset -= INLINE_FILLER_LENGTH;
          offset = offset < 0 ? 0 : offset;
        }

        return new ViewPosition(viewParent, offset);
      } // domParent instanceof HTMLElement.
      else {
          if (domOffset === 0) {
            var _viewParent = this.mapDomToView(domParent);

            if (_viewParent) {
              return new ViewPosition(_viewParent, 0);
            }
          } else {
            var domBefore = domParent.childNodes[domOffset - 1];
            var viewBefore = isText(domBefore) ? this.findCorrespondingViewText(domBefore) : this.mapDomToView(domBefore); // TODO #663

            if (viewBefore && viewBefore.parent) {
              return new ViewPosition(viewBefore.parent, viewBefore.index + 1);
            }
          }

          return null;
        }
    }
    /**
     * Returns corresponding view {@link module:engine/view/element~Element Element} or
     * {@link module:engine/view/documentfragment~DocumentFragment} for provided DOM element or
     * document fragment. If there is no view item {@link module:engine/view/domconverter~DomConverter#bindElements bound}
     * to the given DOM - `undefined` is returned.
     * For all DOM elements rendered by {@link module:engine/view/uielement~UIElement} that UIElement will be returned.
     *
     * @param {DocumentFragment|Element} domElementOrDocumentFragment DOM element or document fragment.
     * @returns {module:engine/view/element~Element|module:engine/view/documentfragment~DocumentFragment|undefined}
     * Corresponding view element, document fragment or `undefined` if no element was bound.
     */

  }, {
    key: "mapDomToView",
    value: function mapDomToView(domElementOrDocumentFragment) {
      return this.getParentUIElement(domElementOrDocumentFragment) || this._domToViewMapping.get(domElementOrDocumentFragment);
    }
    /**
     * Finds corresponding text node. Text nodes are not {@link module:engine/view/domconverter~DomConverter#bindElements bound},
     * corresponding text node is returned based on the sibling or parent.
     *
     * If the directly previous sibling is a {@link module:engine/view/domconverter~DomConverter#bindElements bound} element, it is used
     * to find the corresponding text node.
     *
     * If this is a first child in the parent and the parent is a {@link module:engine/view/domconverter~DomConverter#bindElements bound}
     * element, it is used to find the corresponding text node.
     *
     * For all text nodes rendered by {@link module:engine/view/uielement~UIElement} that UIElement will be returned.
     *
     * Otherwise `null` is returned.
     *
     * Note that for the block or inline {@link module:engine/view/filler filler} this method returns `null`.
     *
     * @param {Text} domText DOM text node.
     * @returns {module:engine/view/text~Text|null} Corresponding view text node or `null`, if it was not possible to find a
     * corresponding node.
     */

  }, {
    key: "findCorrespondingViewText",
    value: function findCorrespondingViewText(domText) {
      if (isInlineFiller(domText)) {
        return null;
      } // If DOM text was rendered by UIElement - return that element.


      var uiElement = this.getParentUIElement(domText);

      if (uiElement) {
        return uiElement;
      }

      var previousSibling = domText.previousSibling; // Try to use previous sibling to find the corresponding text node.

      if (previousSibling) {
        if (!this.isElement(previousSibling)) {
          // The previous is text or comment.
          return null;
        }

        var viewElement = this.mapDomToView(previousSibling);

        if (viewElement) {
          var nextSibling = viewElement.nextSibling; // It might be filler which has no corresponding view node.

          if (nextSibling instanceof ViewText) {
            return viewElement.nextSibling;
          } else {
            return null;
          }
        }
      } // Try to use parent to find the corresponding text node.
      else {
          var _viewElement = this.mapDomToView(domText.parentNode);

          if (_viewElement) {
            var firstChild = _viewElement.getChild(0); // It might be filler which has no corresponding view node.


            if (firstChild instanceof ViewText) {
              return firstChild;
            } else {
              return null;
            }
          }
        }

      return null;
    }
    /**
     * Returns corresponding DOM item for provided {@link module:engine/view/element~Element Element} or
     * {@link module:engine/view/documentfragment~DocumentFragment DocumentFragment}.
     * To find a corresponding text for {@link module:engine/view/text~Text view Text instance}
     * use {@link #findCorrespondingDomText}.
     *
     * @param {module:engine/view/element~Element|module:engine/view/documentfragment~DocumentFragment} viewNode
     * View element or document fragment.
     * @returns {Node|DocumentFragment|undefined} Corresponding DOM node or document fragment.
     */

  }, {
    key: "mapViewToDom",
    value: function mapViewToDom(documentFragmentOrElement) {
      return this._viewToDomMapping.get(documentFragmentOrElement);
    }
    /**
     * Finds corresponding text node. Text nodes are not {@link module:engine/view/domconverter~DomConverter#bindElements bound},
     * corresponding text node is returned based on the sibling or parent.
     *
     * If the directly previous sibling is a {@link module:engine/view/domconverter~DomConverter#bindElements bound} element, it is used
     * to find the corresponding text node.
     *
     * If this is a first child in the parent and the parent is a {@link module:engine/view/domconverter~DomConverter#bindElements bound}
     * element, it is used to find the corresponding text node.
     *
     * Otherwise `null` is returned.
     *
     * @param {module:engine/view/text~Text} viewText View text node.
     * @returns {Text|null} Corresponding DOM text node or `null`, if it was not possible to find a corresponding node.
     */

  }, {
    key: "findCorrespondingDomText",
    value: function findCorrespondingDomText(viewText) {
      var previousSibling = viewText.previousSibling; // Try to use previous sibling to find the corresponding text node.

      if (previousSibling && this.mapViewToDom(previousSibling)) {
        return this.mapViewToDom(previousSibling).nextSibling;
      } // If this is a first node, try to use parent to find the corresponding text node.


      if (!previousSibling && viewText.parent && this.mapViewToDom(viewText.parent)) {
        return this.mapViewToDom(viewText.parent).childNodes[0];
      }

      return null;
    }
    /**
     * Focuses DOM editable that is corresponding to provided {@link module:engine/view/editableelement~EditableElement}.
     *
     * @param {module:engine/view/editableelement~EditableElement} viewEditable
     */

  }, {
    key: "focus",
    value: function focus(viewEditable) {
      var domEditable = this.mapViewToDom(viewEditable);

      if (domEditable && domEditable.ownerDocument.activeElement !== domEditable) {
        // Save the scrollX and scrollY positions before the focus.
        var _global$window = global.window,
            scrollX = _global$window.scrollX,
            scrollY = _global$window.scrollY;
        var scrollPositions = []; // Save all scrollLeft and scrollTop values starting from domEditable up to
        // document#documentElement.

        forEachDomNodeAncestor(domEditable, function (node) {
          var scrollLeft = node.scrollLeft,
              scrollTop = node.scrollTop;
          scrollPositions.push([scrollLeft, scrollTop]);
        });
        domEditable.focus(); // Restore scrollLeft and scrollTop values starting from domEditable up to
        // document#documentElement.
        // https://github.com/ckeditor/ckeditor5-engine/issues/951
        // https://github.com/ckeditor/ckeditor5-engine/issues/957

        forEachDomNodeAncestor(domEditable, function (node) {
          var _scrollPositions$shif = scrollPositions.shift(),
              _scrollPositions$shif2 = _slicedToArray(_scrollPositions$shif, 2),
              scrollLeft = _scrollPositions$shif2[0],
              scrollTop = _scrollPositions$shif2[1];

          node.scrollLeft = scrollLeft;
          node.scrollTop = scrollTop;
        }); // Restore the scrollX and scrollY positions after the focus.
        // https://github.com/ckeditor/ckeditor5-engine/issues/951

        global.window.scrollTo(scrollX, scrollY);
      }
    }
    /**
     * Returns `true` when `node.nodeType` equals `Node.ELEMENT_NODE`.
     *
     * @param {Node} node Node to check.
     * @returns {Boolean}
     */

  }, {
    key: "isElement",
    value: function isElement(node) {
      return node && node.nodeType == Node.ELEMENT_NODE;
    }
    /**
     * Returns `true` when `node.nodeType` equals `Node.DOCUMENT_FRAGMENT_NODE`.
     *
     * @param {Node} node Node to check.
     * @returns {Boolean}
     */

  }, {
    key: "isDocumentFragment",
    value: function isDocumentFragment(node) {
      return node && node.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
    }
    /**
     * Returns `true` when `node.nodeType` equals `Node.COMMENT_NODE`.
     *
     * @param {Node} node Node to check.
     * @returns {Boolean}
     */

  }, {
    key: "isComment",
    value: function isComment(node) {
      return node && node.nodeType == Node.COMMENT_NODE;
    }
    /**
     * Checks if the node is an instance of the block filler for this DOM converter.
     *
     *		const converter = new DomConverter( viewDocument, { blockFillerMode: 'br' } );
     *
     *		converter.isBlockFiller( BR_FILLER( document ) ); // true
     *		converter.isBlockFiller( NBSP_FILLER( document ) ); // false
     *
     * **Note:**: For the `'nbsp'` mode the method also checks context of a node so it cannot be a detached node.
     *
     * **Note:** A special case in the `'nbsp'` mode exists where the `<br>` in `<p><br></p>` is treated as a block filler.
     *
     * @param {Node} domNode DOM node to check.
     * @returns {Boolean} True if a node is considered a block filler for given mode.
     */

  }, {
    key: "isBlockFiller",
    value: function isBlockFiller(domNode) {
      if (this.blockFillerMode == 'br') {
        return domNode.isEqualNode(BR_FILLER_REF);
      } // Special case for <p><br></p> in which case the <br> should be treated as filler even
      // when we're in the 'nbsp' mode. See ckeditor5#5564.


      if (domNode.tagName === 'BR' && hasBlockParent(domNode, this.blockElements) && domNode.parentNode.childNodes.length === 1) {
        return true;
      }

      return isNbspBlockFiller(domNode, this.blockElements);
    }
    /**
     * Returns `true` if given selection is a backward selection, that is, if it's `focus` is before `anchor`.
     *
     * @param {Selection} DOM Selection instance to check.
     * @returns {Boolean}
     */

  }, {
    key: "isDomSelectionBackward",
    value: function isDomSelectionBackward(selection) {
      if (selection.isCollapsed) {
        return false;
      } // Since it takes multiple lines of code to check whether a "DOM Position" is before/after another "DOM Position",
      // we will use the fact that range will collapse if it's end is before it's start.


      var range = document.createRange();
      range.setStart(selection.anchorNode, selection.anchorOffset);
      range.setEnd(selection.focusNode, selection.focusOffset);
      var backward = range.collapsed;
      range.detach();
      return backward;
    }
    /**
     * Returns parent {@link module:engine/view/uielement~UIElement} for provided DOM node. Returns `null` if there is no
     * parent UIElement.
     *
     * @param {Node} domNode
     * @returns {module:engine/view/uielement~UIElement|null}
     */

  }, {
    key: "getParentUIElement",
    value: function getParentUIElement(domNode) {
      var ancestors = getAncestors(domNode); // Remove domNode from the list.

      ancestors.pop();

      while (ancestors.length) {
        var _domNode = ancestors.pop();

        var viewNode = this._domToViewMapping.get(_domNode);

        if (viewNode && viewNode.is('uiElement')) {
          return viewNode;
        }
      }

      return null;
    }
    /**
     * Checks if given selection's boundaries are at correct places.
     *
     * The following places are considered as incorrect for selection boundaries:
     * * before or in the middle of the inline filler sequence,
     * * inside the DOM element which represents {@link module:engine/view/uielement~UIElement a view ui element}.
     *
     * @param {Selection} domSelection DOM Selection object to be checked.
     * @returns {Boolean} `true` if the given selection is at a correct place, `false` otherwise.
     */

  }, {
    key: "isDomSelectionCorrect",
    value: function isDomSelectionCorrect(domSelection) {
      return this._isDomSelectionPositionCorrect(domSelection.anchorNode, domSelection.anchorOffset) && this._isDomSelectionPositionCorrect(domSelection.focusNode, domSelection.focusOffset);
    }
    /**
     * Checks if the given DOM position is a correct place for selection boundary. See {@link #isDomSelectionCorrect}.
     *
     * @private
     * @param {Element} domParent Position parent.
     * @param {Number} offset Position offset.
     * @returns {Boolean} `true` if given position is at a correct place for selection boundary, `false` otherwise.
     */

  }, {
    key: "_isDomSelectionPositionCorrect",
    value: function _isDomSelectionPositionCorrect(domParent, offset) {
      // If selection is before or in the middle of inline filler string, it is incorrect.
      if (isText(domParent) && startsWithFiller(domParent) && offset < INLINE_FILLER_LENGTH) {
        // Selection in a text node, at wrong position (before or in the middle of filler).
        return false;
      }

      if (this.isElement(domParent) && startsWithFiller(domParent.childNodes[offset])) {
        // Selection in an element node, before filler text node.
        return false;
      }

      var viewParent = this.mapDomToView(domParent); // If selection is in `view.UIElement`, it is incorrect. Note that `mapDomToView()` returns `view.UIElement`
      // also for any dom element that is inside the view ui element (so we don't need to perform any additional checks).

      if (viewParent && viewParent.is('uiElement')) {
        return false;
      }

      return true;
    }
    /**
     * Takes text data from a given {@link module:engine/view/text~Text#data} and processes it so
     * it is correctly displayed in the DOM.
     *
     * Following changes are done:
     *
     * * a space at the beginning is changed to `&nbsp;` if this is the first text node in its container
     * element or if a previous text node ends with a space character,
     * * space at the end of the text node is changed to `&nbsp;` if there are two spaces at the end of a node or if next node
     * starts with a space or if it is the last text node in its container,
     * * remaining spaces are replaced to a chain of spaces and `&nbsp;` (e.g. `'x   x'` becomes `'x &nbsp; x'`).
     *
     * Content of {@link #preElements} is not processed.
     *
     * @private
     * @param {module:engine/view/text~Text} node View text node to process.
     * @returns {String} Processed text data.
     */

  }, {
    key: "_processDataFromViewText",
    value: function _processDataFromViewText(node) {
      var _this = this;

      var data = node.data; // If any of node ancestors has a name which is in `preElements` array, then currently processed
      // view text node is (will be) in preformatted element. We should not change whitespaces then.

      if (node.getAncestors().some(function (parent) {
        return _this.preElements.includes(parent.name);
      })) {
        return data;
      } // 1. Replace the first space with a nbsp if the previous node ends with a space or there is no previous node
      // (container element boundary).


      if (data.charAt(0) == ' ') {
        var prevNode = this._getTouchingViewTextNode(node, false);

        var prevEndsWithSpace = prevNode && this._nodeEndsWithSpace(prevNode);

        if (prevEndsWithSpace || !prevNode) {
          data = "\xA0" + data.substr(1);
        }
      } // 2. Replace the last space with nbsp if there are two spaces at the end or if the next node starts with space or there is no
      // next node (container element boundary).
      //
      // Keep in mind that Firefox prefers $nbsp; before tag, not inside it:
      //
      // Foo <span>&nbsp;bar</span>  <-- bad.
      // Foo&nbsp;<span> bar</span>  <-- good.
      //
      // More here: https://github.com/ckeditor/ckeditor5-engine/issues/1747.


      if (data.charAt(data.length - 1) == ' ') {
        var nextNode = this._getTouchingViewTextNode(node, true);

        if (data.charAt(data.length - 2) == ' ' || !nextNode || nextNode.data.charAt(0) == ' ') {
          data = data.substr(0, data.length - 1) + "\xA0";
        }
      } // 3. Create space+nbsp pairs.


      return data.replace(/ {2}/g, " \xA0");
    }
    /**
     * Checks whether given node ends with a space character after changing appropriate space characters to `&nbsp;`s.
     *
     * @private
     * @param {module:engine/view/text~Text} node Node to check.
     * @returns {Boolean} `true` if given `node` ends with space, `false` otherwise.
     */

  }, {
    key: "_nodeEndsWithSpace",
    value: function _nodeEndsWithSpace(node) {
      var _this2 = this;

      if (node.getAncestors().some(function (parent) {
        return _this2.preElements.includes(parent.name);
      })) {
        return false;
      }

      var data = this._processDataFromViewText(node);

      return data.charAt(data.length - 1) == ' ';
    }
    /**
     * Takes text data from native `Text` node and processes it to a correct {@link module:engine/view/text~Text view text node} data.
     *
     * Following changes are done:
     *
     * * multiple whitespaces are replaced to a single space,
     * * space at the beginning of a text node is removed if it is the first text node in its container
     * element or if the previous text node ends with a space character,
     * * space at the end of the text node is removed if there are two spaces at the end of a node or if next node
     * starts with a space or if it is the last text node in its container
     * * nbsps are converted to spaces.
     *
     * @param {Node} node DOM text node to process.
     * @returns {String} Processed data.
     * @private
     */

  }, {
    key: "_processDataFromDomText",
    value: function _processDataFromDomText(node) {
      var data = node.data;

      if (_hasDomParentOfType(node, this.preElements)) {
        return getDataWithoutFiller(node);
      } // Change all consecutive whitespace characters (from the [ \n\t\r] set –
      // see https://github.com/ckeditor/ckeditor5-engine/issues/822#issuecomment-311670249) to a single space character.
      // That's how multiple whitespaces are treated when rendered, so we normalize those whitespaces.
      // We're replacing 1+ (and not 2+) to also normalize singular \n\t\r characters (#822).


      data = data.replace(/[ \n\t\r]{1,}/g, ' ');

      var prevNode = this._getTouchingInlineDomNode(node, false);

      var nextNode = this._getTouchingInlineDomNode(node, true);

      var shouldLeftTrim = this._checkShouldLeftTrimDomText(prevNode);

      var shouldRightTrim = this._checkShouldRightTrimDomText(node, nextNode); // If the previous dom text node does not exist or it ends by whitespace character, remove space character from the beginning
      // of this text node. Such space character is treated as a whitespace.


      if (shouldLeftTrim) {
        data = data.replace(/^ /, '');
      } // If the next text node does not exist remove space character from the end of this text node.


      if (shouldRightTrim) {
        data = data.replace(/ $/, '');
      } // At the beginning and end of a block element, Firefox inserts normal space + <br> instead of non-breaking space.
      // This means that the text node starts/end with normal space instead of non-breaking space.
      // This causes a problem because the normal space would be removed in `.replace` calls above. To prevent that,
      // the inline filler is removed only after the data is initially processed (by the `.replace` above). See ckeditor5#692.


      data = getDataWithoutFiller(new Text(data)); // At this point we should have removed all whitespaces from DOM text data.
      //
      // Now, We will reverse the process that happens in `_processDataFromViewText`.
      //
      // We have to change &nbsp; chars, that were in DOM text data because of rendering reasons, to spaces.
      // First, change all ` \u00A0` pairs (space + &nbsp;) to two spaces. DOM converter changes two spaces from model/view to
      // ` \u00A0` to ensure proper rendering. Since here we convert back, we recognize those pairs and change them back to `  `.

      data = data.replace(/ \u00A0/g, '  '); // Then, let's change the last nbsp to a space.

      if (/( |\u00A0)\u00A0$/.test(data) || !nextNode || nextNode.data && nextNode.data.charAt(0) == ' ') {
        data = data.replace(/\u00A0$/, ' ');
      } // Then, change &nbsp; character that is at the beginning of the text node to space character.
      // We do that replacement only if this is the first node or the previous node ends on whitespace character.


      if (shouldLeftTrim) {
        data = data.replace(/^\u00A0/, ' ');
      } // At this point, all whitespaces should be removed and all &nbsp; created for rendering reasons should be
      // changed to normal space. All left &nbsp; are &nbsp; inserted intentionally.


      return data;
    }
    /**
     * Helper function which checks if a DOM text node, preceded by the given `prevNode` should
     * be trimmed from the left side.
     *
     * @param {Node} prevNode
     */

  }, {
    key: "_checkShouldLeftTrimDomText",
    value: function _checkShouldLeftTrimDomText(prevNode) {
      if (!prevNode) {
        return true;
      }

      if (isElement(prevNode)) {
        return true;
      }

      return /[^\S\u00A0]/.test(prevNode.data.charAt(prevNode.data.length - 1));
    }
    /**
     * Helper function which checks if a DOM text node, succeeded by the given `nextNode` should
     * be trimmed from the right side.
     *
     * @param {Node} node
     * @param {Node} nextNode
     */

  }, {
    key: "_checkShouldRightTrimDomText",
    value: function _checkShouldRightTrimDomText(node, nextNode) {
      if (nextNode) {
        return false;
      }

      return !startsWithFiller(node);
    }
    /**
     * Helper function. For given {@link module:engine/view/text~Text view text node}, it finds previous or next sibling
     * that is contained in the same container element. If there is no such sibling, `null` is returned.
     *
     * @param {module:engine/view/text~Text} node Reference node.
     * @param {Boolean} getNext
     * @returns {module:engine/view/text~Text|null} Touching text node or `null` if there is no next or previous touching text node.
     */

  }, {
    key: "_getTouchingViewTextNode",
    value: function _getTouchingViewTextNode(node, getNext) {
      var treeWalker = new ViewTreeWalker({
        startPosition: getNext ? ViewPosition._createAfter(node) : ViewPosition._createBefore(node),
        direction: getNext ? 'forward' : 'backward'
      });
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = treeWalker[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var value = _step5.value;

          // ViewContainerElement is found on a way to next ViewText node, so given `node` was first/last
          // text node in its container element.
          if (value.item.is('containerElement')) {
            return null;
          } // <br> found – it works like a block boundary, so do not scan further.
          else if (value.item.is('br')) {
              return null;
            } // Found a text node in the same container element.
            else if (value.item.is('textProxy')) {
                return value.item;
              }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return null;
    }
    /**
     * Helper function. For the given text node, it finds the closest touching node which is either
     * a text node or a `<br>`. The search is terminated at block element boundaries and if a matching node
     * wasn't found so far, `null` is returned.
     *
     * In the following DOM structure:
     *
     *		<p>foo<b>bar</b><br>bom</p>
     *
     * * `foo` doesn't have its previous touching inline node (`null` is returned),
     * * `foo`'s next touching inline node is `bar`
     * * `bar`'s next touching inline node is `<br>`
     *
     * This method returns text nodes and `<br>` elements because these types of nodes affect how
     * spaces in the given text node need to be converted.
     *
     * @private
     * @param {Text} node
     * @param {Boolean} getNext
     * @returns {Text|Element|null}
     */

  }, {
    key: "_getTouchingInlineDomNode",
    value: function _getTouchingInlineDomNode(node, getNext) {
      if (!node.parentNode) {
        return null;
      }

      var direction = getNext ? 'nextNode' : 'previousNode';
      var document = node.ownerDocument;
      var topmostParent = getAncestors(node)[0];
      var treeWalker = document.createTreeWalker(topmostParent, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, {
        acceptNode: function acceptNode(node) {
          if (isText(node)) {
            return NodeFilter.FILTER_ACCEPT;
          }

          if (node.tagName == 'BR') {
            return NodeFilter.FILTER_ACCEPT;
          }

          return NodeFilter.FILTER_SKIP;
        }
      });
      treeWalker.currentNode = node;
      var touchingNode = treeWalker[direction]();

      if (touchingNode !== null) {
        var lca = getCommonAncestor(node, touchingNode); // If there is common ancestor between the text node and next/prev text node,
        // and there are no block elements on a way from the text node to that ancestor,
        // and there are no block elements on a way from next/prev text node to that ancestor...

        if (lca && !_hasDomParentOfType(node, this.blockElements, lca) && !_hasDomParentOfType(touchingNode, this.blockElements, lca)) {
          // Then they are in the same container element.
          return touchingNode;
        }
      }

      return null;
    }
  }]);

  return DomConverter;
}(); // Helper function.
// Used to check if given native `Element` or `Text` node has parent with tag name from `types` array.
//
// @param {Node} node
// @param {Array.<String>} types
// @param {Boolean} [boundaryParent] Can be given if parents should be checked up to a given element (excluding that element).
// @returns {Boolean} `true` if such parent exists or `false` if it does not.


export { DomConverter as default };

function _hasDomParentOfType(node, types, boundaryParent) {
  var parents = getAncestors(node);

  if (boundaryParent) {
    parents = parents.slice(parents.indexOf(boundaryParent) + 1);
  }

  return parents.some(function (parent) {
    return parent.tagName && types.includes(parent.tagName.toLowerCase());
  });
} // A helper that executes given callback for each DOM node's ancestor, starting from the given node
// and ending in document#documentElement.
//
// @param {Node} node
// @param {Function} callback A callback to be executed for each ancestor.


function forEachDomNodeAncestor(node, callback) {
  while (node && node != global.document) {
    callback(node);
    node = node.parentNode;
  }
} // Checks if given node is a nbsp block filler.
//
// A &nbsp; is a block filler only if it is a single child of a block element.
//
// @param {Node} domNode DOM node.
// @returns {Boolean}


function isNbspBlockFiller(domNode, blockElements) {
  var isNBSP = isText(domNode) && domNode.data == "\xA0";
  return isNBSP && hasBlockParent(domNode, blockElements) && domNode.parentNode.childNodes.length === 1;
} // Checks if domNode has block parent.
//
// @param {Node} domNode DOM node.
// @returns {Boolean}


function hasBlockParent(domNode, blockElements) {
  var parent = domNode.parentNode;
  return parent && parent.tagName && blockElements.includes(parent.tagName.toLowerCase());
}
/**
 * Enum representing type of the block filler.
 *
 * Possible values:
 *
 * * `br` - for `<br>` block filler used in editing view,
 * * `nbsp` - for `&nbsp;` block fillers used in the data.
 *
 * @typedef {String} module:engine/view/filler~BlockFillerMode
 */